export default __webpack_public_path__ + "static/media/InsideBones_11.e709c395.png";